import { render, staticRenderFns } from "./PtPurchaseForm.vue?vue&type=template&id=d90528b2&scoped=true&"
import script from "./PtPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./PtPurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90528b2",
  null
  
)

export default component.exports